//console.log("Initialize Route");

import Vue from 'vue';
import VueRouter from 'vue-router';

// VueRouter
Vue.use(VueRouter);

// パスとコンポーネントのマッピング
const routes = [
    // =================================================================================================================
    // 共通画面

    // ログイン
    {
        path: '/login',
        component: require('./components/designed/common/Login.vue').default,
        meta: { requiresAuth: false, title: 'ログイン', class: "page-login" },
    },

    // =================================================================================================================
    // ユーザー側
    {
        path: '/user/categories',
        component: require('./components/designed/user/CategorySelect.vue').default,
        meta: { requiresAuth: true, title: 'カテゴリ選択', isOfflineCompliant: true, class: "page-categories" },
    },

    // タスク選択画面
    {
        path: '/user/tasks/:category',
        component: require('./components/designed/user/TaskSelect.vue').default,
        meta: { requiresAuth: true, title: 'タスク選択', isOfflineCompliant: true, class: "page-tasks" },
    },

    // チェックリスト画面
    {
        path: '/user/checklist/:task_id',
        component: require('./components/designed/user/Checklist.vue').default,
        meta: { requiresAuth: true, title: 'チェックリスト', isOfflineCompliant: true, class: "page-checklist" },
    },

    // ダウンロードしたタスク一覧画面
    {
        path: '/user/download',
        component: require('./components/designed/user/DownloadList.vue').default,
        meta: { requiresAuth: true, title: 'ダウンロードしたタスク一覧', isOfflineCompliant: true, class: "page-download" },
    },
    // =================================================================================================================
    // 管理メニュー画面
    {
        path: '/admin/menu',
        component: require('./components/designed/admin/Menu.vue').default,
        meta: { requiresAuth: true, title: '設定/登録' },
    },

    // ユーザー一覧画面
    {
        path: '/admin/users',
        component: require('./components/designed/admin/UserList.vue').default,
        meta: { requiresAuth: true, title: 'ユーザー登録/編集' },
    },

    // ユーザー新規登録画面  /* 2020/2/5追加　F2 No.65:ページタイトル修正対応 パラメータは/0だけ通す */
    {
        path: '/admin/user/:userId(0)',
        component: require('./components/designed/admin/UserEdit.vue').default,
        meta: { requiresAuth: true, title: 'ユーザー登録' },
        props: { register: true },
    },
    // ユーザー編集画面
    {
        path: '/admin/user/:userId(\\d+)',
        component: require('./components/designed/admin/UserEdit.vue').default,
        meta: { requiresAuth: true, title: 'ユーザー編集' },
        props: { register: false },
    },
    // グループ一覧画面
    {
        path: '/admin/groups',
        component: require('./components/designed/admin/GroupList.vue').default,
        meta: { requiresAuth: true, title: 'グループ登録/編集' },
    },
    // グループ新規登録画面  /* 2020/2/5追加　F2 No.65:ページタイトル修正対応 パラメータは/0だけ通す */
    {
        path: '/admin/group/:groupId(0)',
        component: require('./components/designed/admin/GroupEdit.vue').default,
        meta: { requiresAuth: true, title: 'グループ登録' },
        props: { register: true },
    },

    // グループ編集画面
    {
        path: '/admin/group/:groupId(\\d+)',
        component: require('./components/designed/admin/GroupEdit.vue').default,
        meta: { requiresAuth: true, title: 'グループ編集' },
        props: { register: false },
    },

    // カテゴリ一覧画面
    {
        path: '/admin/categories',
        component: require('./components/designed/admin/CategoryList.vue').default,
        meta: { requiresAuth: true, title: 'カテゴリ登録/編集' },
    },

    // カテゴリ新規登録  /* 2020/2/5追加　F2 No.65:ページタイトル修正対応 パラメータは/0だけ通す */
    {
        path: '/admin/category/:categoryId(0)',
        component: require('./components/designed/admin/CategoryEdit.vue').default,
        meta: { requiresAuth: true, title: 'カテゴリ登録' },
        props: { register: true },
    },

    // カテゴリ編集
    {
        path: '/admin/category/:categoryId(\\d+)',
        component: require('./components/designed/admin/CategoryEdit.vue').default,
        meta: { requiresAuth: true, title: 'カテゴリ編集' },
        props: { register: false },
    },

    // タスク一覧画面
    {
        path: '/admin/tasks',
        component: require('./components/designed/admin/TaskList.vue').default,
        meta: { requiresAuth: true, title: 'タスク登録/編集' },
    },
    // タスク新規登録画面  /* 2020/2/5追加　F2 No.65:ページタイトル修正対応 パラメータは/0だけ通す */
    {
        path: '/admin/task/:id(0)',
        component: require('./components/designed/admin/TaskEdit.vue').default,
        meta: { requiresAuth: true, title: 'タスク登録' },
        props: { register: true },
    },

    // タスク編集画面
    {
        path: '/admin/task/:id(\\d+)',
        component: require('./components/designed/admin/TaskEdit.vue').default,
        meta: { requiresAuth: true, title: 'タスク編集' },
        props: { register: false },
    },
    // チェックリスト編集画面
    {
        path: '/admin/checklist/:task_id',
        component: require('./components/designed/admin/ChecklistEdit.vue').default,
        meta: { requiresAuth: true, title: 'チェックリスト登録/編集' },
    },
    {
        path: '/admin/preview',
        component: require('./components/designed/admin/Preview.vue').default,
        meta: { requiresAuth: true, title: 'チェックリストプレビュー' },
    },

    // タグ一覧画面
    {
        path: '/admin/tags',
        component: require('./components/designed/admin/TagList.vue').default,
        meta: { requiresAuth: true, title: 'タグ登録/編集' },
    },
    // タグ新規登録画面   /* 2020/2/5追加　F2 No.65:ページタイトル修正対応 パラメータは/0だけ通す */
    {
        path: '/admin/tag/:tagId(0)',
        component: require('./components/designed/admin/TagEdit.vue').default,
        meta: { requiresAuth: true, title: 'タグ登録' },
        props: { register: true },
    },

    // タグ編集画面
    {
        path: '/admin/tag/:tagId(\\d+)',
        component: require('./components/designed/admin/TagEdit.vue').default,
        meta: { requiresAuth: true, title: 'タグ編集' },
        props: { register: false },
    },


    // 閲覧ログ ダッシュボード
    {
        name: 'log-index',
        path: '/admin/logs',
        component: require('./components/designed/admin/LogDashboard.vue').default,
        meta: { requiresAuth: true, title: '閲覧ログ - ダッシュボード' },
    },
    // 閲覧ログ ユーザー
    {
        name: 'log-users',
        path: '/admin/logs/users',
        component: require('./components/designed/admin/LogUsers.vue').default,
        meta: { requiresAuth: true, title: '閲覧ログ - ユーザー' },
    },
    // 閲覧ログ 個別ユーザー
    {
        name: 'log-user',
        path: '/admin/logs/users/:user_id',
        component: require('./components/designed/admin/LogUser.vue').default,
        meta: { requiresAuth: true, title: '閲覧ログ - ユーザー' },
    },
    // 閲覧ログ コンテンツ
    {
        name: 'log-contents',
        path: '/admin/logs/contents',
        component: require('./components/designed/admin/LogContents.vue').default,
        meta: { requiresAuth: true, title: '閲覧ログ - コンテンツ' },
    },
    // 閲覧ログ タスク更新履歴
    {
        name: 'log-task-updates',
        path: '/admin/logs/task_updates',
        component: require('./components/designed/admin/LogTaskUpdates.vue').default,
        meta: { requiresAuth: true, title: '閲覧ログ - タスク更新履歴' },
    },
    // 閲覧ログ 作業履歴
    {
        name: 'log-work-procedures-task',
        path: '/admin/logs/work_procedures/:user_id/:task__id',
        component: require('./components/designed/admin/LogWorkProcedures.vue').default,
        meta: { requiresAuth: true, title: '作業履歴' },
    },
    {
        name: 'log-work-procedures-user',
        path: '/admin/logs/work_procedures/:user_id',
        component: require('./components/designed/admin/LogWorkProcedures.vue').default,
        meta: { requiresAuth: true, title: '作業履歴' },
    },
    {
        name: 'log-work-procedures',
        path: '/admin/logs/work_procedures',
        component: require('./components/designed/admin/LogWorkProcedures.vue').default,
        meta: { requiresAuth: true, title: '閲覧ログ - ユーザー作業履歴' },
    },

    {
        name: 'admin-menu',
        path: '/design/admin/menu',
        component: require('./components/designed/admin/Menu.vue').default,
        meta: { requiresAuth: true, title: '管理画面トップ' },
    },

    // =================================================================================================================
    // Not Found
    {
        path: '*',
        component: require('./components/commons/NotFoundComponent.vue')
            .default,
        meta: { requiresAuth: false, title: 'Not Found', isOfflineCompliant: true },
    },

    // =================================================================================================================
];

// VueRouterインスタンスを作成する
const router = new VueRouter({
    // mode: 'hash',
    base: process.env.MIX_VUEROOTER_BASE,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },
});

// VueRouterインスタンスをエクスポートする
// app.jsでインポートするため
export default router;